import {gql} from "@apollo/client";

export const resetPasswordMutation = gql`
  mutation ResetPassword($email: String!, $lang: LanguageCode) {
    ok: resetPassword(email: $email, languageCode: $lang)
  }
`
